import { LAYOUTS } from '@voltmoney/types';
import { ROUTE } from '../../routes';
import { WIDGET } from "@voltmoney/schema";
import { horizontalStepperRepo } from "../../configs/utils";
import { api } from "../../configs/api";
import { getAppHeader } from "../../configs/config";
import SharedPropsService from "../../SharedPropsService";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { ACTION } from "./types";
import { agreementAction, backActionAgreement, closeFailureCard, goBackAction, goToAgreementPage, kfsCancelAction, kfsSuccessAction, NavToDashboard, openLinkInNewTab, openLinkInNewTabKfs } from "./actions";
import { checkApplicationStatusForKFS, renderAgreementLoaderDataStore, renderAgreementLoaderLayout } from "./utils";
export const template = async (height, stepperData, stepperResponse, isPollingForSFDCGeneration) => {
    return {
        layout: {
            id: ROUTE.BAJAJ_AGREEMENT_STEPPER,
            type: LAYOUTS.LIST,
            widgets: [
                ...await renderAgreementLoaderLayout(isPollingForSFDCGeneration),
                !isPollingForSFDCGeneration ? {
                    id: "bajajAgreementStepperDC",
                    type: WIDGET.BAJAJ_AGREEMENT_STEPPER
                } : {}
            ],
        },
        datastore: {
            ...await renderAgreementLoaderDataStore(stepperData),
            bajajAgreementStepperDC: {
                height: height,
                stepperData: stepperData,
                bajajAgreementStepperData: stepperResponse,
                continueAction: {
                    type: ACTION.CONTINUE_ACTION,
                    routeId: ROUTE.BAJAJ_AGREEMENT_STEPPER,
                    payload: {}
                },
                agreementAction: {
                    type: ACTION.AGREEMENT_ACTION,
                    routeId: ROUTE.BAJAJ_AGREEMENT_STEPPER,
                    payload: {}
                },
                goToAgreementPage: {
                    type: ACTION.GO_TO_AGREEMENT_PAGE,
                    routeId: ROUTE.BAJAJ_AGREEMENT_STEPPER,
                    payload: {}
                },
                openTabAction: {
                    type: ACTION.OPEN_TAB,
                    routeId: ROUTE.BAJAJ_AGREEMENT_STEPPER,
                    payload: {}
                },
                verificationSuccessAction: {
                    type: ACTION.VERIFICATION_SUCCESS,
                    routeId: ROUTE.BAJAJ_AGREEMENT_STEPPER,
                    payload: {}
                },
                backAction: {
                    type: ACTION.BACK_ACTION,
                    routeId: ROUTE.BAJAJ_AGREEMENT_STEPPER,
                    payload: {}
                },
                kfsSuccessAction: {
                    type: ACTION.KFS_SUCCESS,
                    routeId: ROUTE.BAJAJ_AGREEMENT_STEPPER,
                    payload: {}
                },
                kfsCancelAction: {
                    type: ACTION.KFS_CANCEL,
                    routeId: ROUTE.BAJAJ_AGREEMENT_STEPPER,
                    payload: {}
                },
                closeFailureCardAction: {
                    type: ACTION.CLOSE_FAILURE_CARD,
                    routeId: ROUTE.BAJAJ_AGREEMENT_STEPPER,
                    payload: {}
                },
                showWebView: false,
                loading: false,
            }
        },
    };
};
export const bajajAgreementStepperMF = {
    onLoad: async ({ network, getHeight, navigateWithClear, removeWidgets }, { shouldPool = true }) => {
        const stepper = await horizontalStepperRepo(network);
        const user = await SharedPropsService.getUser();
        await removeWidgets(ROUTE.BAJAJ_AGREEMENT_STEPPER, [{ id: "bajajAgreementStepperDC", type: WIDGET.BAJAJ_AGREEMENT_STEPPER }]);
        let applicationId = "";
        if (await AsyncStorage.getItem("application_id")) {
            applicationId = await AsyncStorage.getItem("application_id");
        }
        else {
            applicationId = user.linkedApplications[0].applicationId;
        }
        const stepperResponse = await network.get(`${api.getAgreementStepper}${applicationId}`, { headers: await getAppHeader() });
        let isPollingForSFDCGeneration = false;
        if (shouldPool) {
            isPollingForSFDCGeneration = await checkApplicationStatusForKFS({
                network,
                applicationId,
                isPollingForSFDCGeneration,
                navigateWithClear,
                shouldNavigate: false
            });
            if (isPollingForSFDCGeneration !== false) {
                const interval = setInterval(async () => {
                    isPollingForSFDCGeneration = await checkApplicationStatusForKFS({
                        network,
                        applicationId,
                        isPollingForSFDCGeneration,
                        navigateWithClear,
                        poll_interval: interval,
                        shouldNavigate: true
                    });
                }, 5000);
            }
        }
        return Promise.resolve(template(getHeight(), stepper, stepperResponse.data.borrowerViewStepperMap, isPollingForSFDCGeneration));
    },
    actions: {
        [ACTION.CONTINUE_ACTION]: openLinkInNewTabKfs,
        [ACTION.AGREEMENT_ACTION]: agreementAction,
        [ACTION.OPEN_TAB]: openLinkInNewTab,
        [ACTION.VERIFICATION_SUCCESS]: NavToDashboard,
        [ACTION.BACK_ACTION]: backActionAgreement,
        [ACTION.GO_BACK]: goBackAction,
        [ACTION.KFS_SUCCESS]: kfsSuccessAction,
        [ACTION.KFS_CANCEL]: kfsCancelAction,
        [ACTION.GO_TO_AGREEMENT_PAGE]: goToAgreementPage,
        [ACTION.CLOSE_FAILURE_CARD]: closeFailureCard,
    },
    clearPrevious: true,
};
